import React from "react";
import { HOTLINE_STATUS_LABELS, HOTLINE_STATUS_COLORS } from "./constants";

export default function HotlineStatusBadge({ status, testId }) {
  const cfg = HOTLINE_STATUS_COLORS[status] || { color: "#94A3B8", bg: "#94A3B814" };
  return (
    <span
      data-testid={testId || `hotline-status-${status}`}
      className="inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-medium whitespace-nowrap"
      style={{ background: cfg.bg, color: cfg.color }}
    >
      <span className="w-1.5 h-1.5 rounded-full" style={{ background: cfg.color }} />
      {HOTLINE_STATUS_LABELS[status] || status}
    </span>
  );
}
